import { List, Map } from 'immutable'
import { IMenuItem } from 'hooks/useMenu'

const frItems: IMenuItem[] = [
  {
    title: 'Notre fondation',
    columnType: 'foundationCol',
    items: [
      {
        title: 'Notre fondation',
        items: [],
        link: 'https://www.fondation-free.fr/',
        imageUrl: '/fondation_free.png',
        isExternalLink: true
      }
    ]
  },
  {
    title: 'Information',
    items: [
      // A CONSERVER ----------------------->
      // {
      //   title: 'Plateforme éthique et conformité',
      //   items: [],
      //   link: 'https://compliance.iliad.fr/',
      //   isExternalLink: true
      // },
      // A CONSERVER <-----------------------
      {
        title: 'Documentation',
        items: [],
        link: '/fr/documentation/all/all'
      },
      {
        title: 'Indicateurs de qualité de service',
        items: [],
        link: '/fr/qualite-de-service/all/all'
      },
      {
        title: 'Glossaire',
        items: [],
        link: '/fr/glossaire'
      }
    ]
  },
  {
    title: 'Nos filiales',
    items: [
      {
        title: 'Free',
        items: [],
        link: 'https://www.free.fr/',
        isExternalLink: true
      },
      {
        title: 'Free Mobile',
        items: [],
        link: 'https://mobile.free.fr/',
        isExternalLink: true
      },
      {
        title: 'Free Caraïbe',
        items: [],
        link: 'https://caraibe.free.fr/',
        isExternalLink: true
      },
      {
        title: 'TELCO OI',
        items: [],
        link: 'https://telco.re/',
        isExternalLink: true
      },
      {
        title: 'Free Pro Offres Pro',
        items: [],
        link: 'https://pro.free.fr/',
        isExternalLink: true
      },
      {
        title: 'Free Pro Solutions XPR',
        items: [],
        link: 'https://xpr.freepro.com',
        isExternalLink: true
      },
      {
        title: 'Stancer',
        items: [],
        link: 'https://stancer.com/fr/',
        isExternalLink: true
      },
      {
        title: 'Scaleway',
        items: [],
        link: 'https://www.scaleway.com/fr/',
        isExternalLink: true
      },
      {
        title: 'iliad italia',
        items: [],
        link: 'https://www.iliad.it/',
        isExternalLink: true
      },
      {
        title: 'Play',
        items: [],
        link: 'https://www.play.pl',
        isExternalLink: true
      }
    ]
  },
  {
    title: 'Nos communiqués',
    columnType: 'newsletterCol',
    items: [
      {
        title: 'Informations légales',
        items: [],
        link: '/fr/gouvernances/informations-legales'
      }
    ]
  }
]

const enItems: IMenuItem[] = [
  {
    title: 'Our corporate foundation',
    columnType: 'foundationCol',
    items: [
      {
        title: 'The foundation',
        items: [],
        link: 'https://www.fondation-free.fr/',
        imageUrl: '/free_foundation.png',
        isExternalLink: true
      }
    ]
  },
  {
    title: 'Information',
    items: [
      // A CONSERVER ----------------------->
      // {
      //   title: 'Ethics & compliance platform',
      //   items: [],
      //   link: 'https://compliance.iliad.fr/',
      //   isExternalLink: true
      // },
      // A CONSERVER <-----------------------
      {
        title: 'Documentation',
        items: [],
        link: '/en/documentation/all/all'
      },
      {
        title: 'Quality of service',
        items: [],
        link: '/en/qualite-de-service/all/all'
      },
      {
        title: 'Glossary',
        items: [],
        link: '/en/glossaire'
      }
    ]
  },
  {
    title: 'Our subsidiaries',
    items: [
      {
        title: 'Free',
        items: [],
        link: 'https://www.free.fr/',
        isExternalLink: true
      },
      {
        title: 'Free Mobile',
        items: [],
        link: 'https://mobile.free.fr/',
        isExternalLink: true
      },
      {
        title: 'Free Caraïbe',
        items: [],
        link: 'https://caraibe.free.fr/',
        isExternalLink: true
      },
      {
        title: 'TELCO OI',
        items: [],
        link: 'https://telco.re/',
        isExternalLink: true
      },
      {
        title: 'Free Pro Offres Pro',
        items: [],
        link: 'https://pro.free.fr/',
        isExternalLink: true
      },
      {
        title: 'Free Pro Solutions XPR',
        items: [],
        link: 'https://xpr.freepro.com',
        isExternalLink: true
      },
      {
        title: 'Stancer',
        items: [],
        link: 'https://stancer.com/fr/',
        isExternalLink: true
      },
      {
        title: 'Scaleway',
        items: [],
        link: 'https://www.scaleway.com/en/',
        isExternalLink: true
      },
      {
        title: 'iliad italia',
        items: [],
        link: 'https://www.iliad.it/',
        isExternalLink: true
      },
      {
        title: 'Play',
        items: [],
        link: 'https://www.play.pl',
        isExternalLink: true
      }
    ]
  },
  {
    title: 'Our press releases',
    columnType: 'newsletterCol',
    items: [
      {
        title: 'Legal Notices',
        items: [],
        link: '/en/gouvernances/informations-legales'
      }
    ]
  }
]

let localizedMenu = Map<string, List<IMenuItem>>()
localizedMenu = localizedMenu.set('fr', List(frItems))
localizedMenu = localizedMenu.set('en', List(enItems))

export const footer = localizedMenu
